// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__irU7D","content":"styles_content__bFQlr","row":"styles_row__2Vizf","footer":"styles_footer__2mk03","phraseLength":"styles_phraseLength__31uXk"};